module.exports = __webpack_public_path__ + "img/whiteTulip.5d2d534d.jpeg";